import { useEffect, useState, useRef } from "react";

import styles from "./Face2.module.scss";

export default function Face2() {
  const cardRef = useRef<HTMLDivElement>(null);

  const [fontSize, setFontSize] = useState<number | undefined>(undefined);
  const [letterSpacing, setLetterSpacing] = useState<number | undefined>(
    undefined
  );
  const [lineHeight, setLineHeight] = useState<number | undefined>(undefined);
  const [marginLeft, setMarginLeft] = useState<number | undefined>(undefined);

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      if (cardRef.current) {
        setFontSize(Math.floor(0.035 * cardRef.current.clientWidth));
        setLetterSpacing(0.002 * cardRef.current.clientWidth);
        setLineHeight(0.05 * cardRef.current.clientWidth);
        setMarginLeft(0.4 * cardRef.current.clientWidth);
      }
    }

    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount

  return (
    <div ref={cardRef} className={styles.card}>
      <div
        style={{
          fontSize: `${fontSize}px`,
          letterSpacing: `${letterSpacing}px`,
          lineHeight: `${lineHeight}px`,
          marginLeft: `${marginLeft}px`,
          width: "100%",
        }}
      >
        <p>Lutealna faza</p>
        <p>mjesec se davi u Vodenjaku</p>
        <p>Kukovi vire </p>
        <p>žuljaju pojasnicu kepernu</p>
        <p>Ono što želim je</p>
        <p>pušit cigare</p>
        <p>na toplom betonu ispred Rojca.</p>
        <br></br>
        <p>Ali ti si premlada!</p>
        <p>a ti si debil</p>
        <br></br>
        <p>kad bi znao koliko mi je duša stara</p>
        <p>ne bi niti pričali</p>
        <p>pa ne pričamo</p>
        <p>o životima u meni ni koliko ih ima</p>
        <br></br>
        <p>ma kakva Kamala!</p>
        <br></br>
        <p>Ptice nisu slobodne od želje</p>
        <p>ja ne živim jer sam živa</p>
        <p>u lokve sipam gole mrvice</p>
        <p>za osmijeh, moral, usrećivanje.</p>
      </div>
    </div>
  );
}
